<template>
  <v-container>
    <div class="inloggen">
      <v-card max-width="400">
        <v-card-title> Inloggen </v-card-title>
        <v-card-text>
          <v-form ref="form" onsubmit="return false;">
            <v-text-field
              label="Gebruikersnaam"
              v-model="username"
              maxlength="200"
              autofocus
              solo
            ></v-text-field>

            <v-text-field
              label="Wachtwoord"
              v-model="password"
              type="password"
              maxlength="100"
              name="password"
              solo
            ></v-text-field>

            <v-btn type="submit" @click="login()" color="primary"
              >Inloggen</v-btn
            >
            <v-btn text to="PasswordReset">Wachtwoord vergeten</v-btn>
            <v-alert
              type="error"
              v-model="showerrormessage"
              dismissible
              class="mt-4"
              >{{ errormessage }}</v-alert
            >
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      errormessage: null,
      showerrormessage: false,
    };
  },
  methods: {
    loaddata: function () {
      this.$api.Logout();
      this.$root.$emit("logout");
    },
    login: function () {
      this.$api
        .Login({ Username: this.username, Password: this.password })
        .then(() => {
          const url = this.$route.query.ReturnUrl;
          this.$root.$emit("login");
          if (url) {
            this.$router.push(url);
          } else {
            this.$router.push("/start");
          }
        })
        .catch(() => {
          this.errormessage = "Inloggen mislukt.";
          this.showerrormessage = true;
        });
    },
  },
  watch: {
    username: function () {
      this.showerrormessage = false;
    },
    password: function () {
      this.showerrormessage = false;
    },
  },
  created: function () {
    this.loaddata();
  },
};
</script>

<style scoped>
</style>
